export default "__VITE_ASSET__McoXT250__"